<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'ArizaModal',
  props:[
    "subsId",
    "type"
  ],
  data() {
    return {
      form: {},
      groups:[],
      submitted: false,
    };
  },
  validations: {
    form: {
      content: { required },
    },
  },
  watch:{
    subsId(){
      this.getGroups()
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if(this.form.id)
          this.update();
        else
          this.create();
      }
      this.submitted = false;
    },
    create(){
        const { id } = this.$route.params
        this.$http.post(`/members/${id}/faults/store` , this.form)
        .then(resp => {
          this.form = {};
          this.$emit('loadItems')
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    getGroups(){
        const type = this.type ?? null
        this.$http.post(`/technic-service/group/${type}` )
        .then(resp => {
          this.groups = resp.data
        })
        .catch(error => error)
    },
    close(){
      this.$bvModal.hide('ariza_modal')
    },
  },
};
</script>

<template>
  <b-modal id="ariza_modal" title="Yeni Arıza Oluştur"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="title">Arıza Tanımı</label>
                <v-select 
                      :create-option="(tag) => ({ id: tag, name: tag })"
                      class="mb-3"
                      taggable
                      v-model="form.group_id"
                      :options="groups"
                      label="name"
                      :reduce="form => form.id">
                <span slot="no-options">Sonuç Bulunamadı</span>
                </v-select>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <label for="title">Arıza Açıklaması</label>
                <textarea
                        class="form-control"
                        v-model="form.content"
                        rows="4"
                        :class="{
                        'is-invalid': submitted && $v.form.content.$error,
                        }"
                ></textarea>
                <div
                v-if="submitted && !$v.form.content.required"
                class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <label for="title">Arıza Ekleri</label>
                <input type="file" >
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>